/**
 * A tap-to-call link for a phone number as people write it ("+383 (0)44 629-916",
 * "044.629.916"…). Dialers only reliably handle digits and a leading "+", so everything else is
 * removed, including a "(0)" trunk prefix after the country code, which isn't dialled
 * internationally.
 */
export function telHref(phone: string) {
  const digits = phone.replace(/\(0\)/g, '').replace(/[^\d+]/g, '');
  const plus = digits.startsWith('+') ? '+' : '';
  return `tel:${plus}${digits.replace(/\+/g, '')}`;
}
